// Helpers over the backend's CourseGateDetail (GET .../sessionGate/...).
// gate.sessions is in lesson-plan order: one READING session per
// (sectionId, chapterId) plus ASSESSMENT sessions for chapter/section
// assessments. A chapter "passes" only when every one of its sessions passed
// (>= threshold, or attempted-but-unscoreable).

export const chapterSessions = (gate, sectionId, chapterId) =>
  (gate?.sessions || []).filter(
    (s) => s.sectionId === sectionId && s.chapterId === chapterId,
  );

export const chapterPassed = (gate, sectionId, chapterId) => {
  const sessions = chapterSessions(gate, sectionId, chapterId);
  return sessions.length > 0 && sessions.every((s) => s.passed);
};

// First failing (or unattempted) session of a chapter — what the retake
// screen shows. Null when the chapter is fully passed or unknown to the gate.
export const failedChapterSession = (gate, sectionId, chapterId) =>
  chapterSessions(gate, sectionId, chapterId).find((s) => !s.passed) || null;

// First non-passed session across the whole course, in lesson-plan order —
// everything after it is locked (linear lock).
export const firstNonPassed = (gate) =>
  (gate?.sessions || []).find((s) => !s.passed) || null;

// Highest attempt count among a chapter's sessions ("Attempt N" display).
export const chapterAttempts = (gate, sectionId, chapterId) =>
  chapterSessions(gate, sectionId, chapterId).reduce(
    (max, s) => Math.max(max, s.attempts || 0),
    0,
  );
